import { api } from "@/api";
import {
  PayloadRepost,
  PayloadSurveyMonkey,
  PayloadTransmissionAccess,
} from "@/types";
import { AxiosResponse } from "axios";
class API {
  static postNew(payload: any): Promise<AxiosResponse> {
    return api.post("/post", payload);
  }
  static getEvents(): Promise<AxiosResponse> {
    return api.get("/event/list");
  }
  static getCategories(): Promise<AxiosResponse> {
    return api.get("/post/categories");
  }
  static postNewMartekingPost(
    payload: any,
    role: string
  ): Promise<AxiosResponse> {
    const endpoint =
      role === "FOUR_NETWORK" || role === "MARKETING"
        ? "/post/marketing-post"
        : "/post";
    return api.post(endpoint, payload);
  }
  static getQuota(): Promise<AxiosResponse> {
    return api.get("/cota");
  }
  static putMartekingPost(payload: any, role: string): Promise<AxiosResponse> {
    const endpoint =
      role === "FOUR_NETWORK" || role === "MARKETING"
        ? "/post/marketing-post"
        : "/post";
    return api.put(endpoint, payload);
  }
  static getUsersMark(payload: any): Promise<AxiosResponse> {
    return api.get("/profile/markable-users", { params: payload });
  }
  static postRepost(payload: PayloadRepost): Promise<AxiosResponse> {
    return api.post("/post/repost", payload);
  }
  static postWhitePapers(payload: any): Promise<AxiosResponse> {
    return api.post("/post/white-paper", payload);
  }
  static putWhitePapers(payload: any): Promise<AxiosResponse> {
    return api.put("/post/white-paper", payload);
  }
  static putRepost(payload: PayloadRepost): Promise<AxiosResponse> {
    return api.put("/post/repost", payload);
  }
  static postSuccessCase(payload: any): Promise<AxiosResponse> {
    return api.post("/post/success-case", payload);
  }
  static putSuccessCase(payload: any): Promise<AxiosResponse> {
    return api.put("/post/success-case", payload);
  }
  static getActiveEvents(): Promise<AxiosResponse> {
    return api.get("/event/list/active");
  }
  static postJournal(payload: any): Promise<AxiosResponse> {
    return api.post("/post/journal", payload);
  }
  static putJournal(payload: any): Promise<AxiosResponse> {
    return api.put("/post/journal", payload);
  }
  static getSurveyMonkey(payload: PayloadSurveyMonkey): Promise<AxiosResponse> {
    return api.get("/survey-monkey/surveys", { params: payload });
  }
  static postSurveyMonkey(payload: any): Promise<AxiosResponse> {
    return api.post("/post/survey/survey-monkey", payload);
  }
  static putSurveyMonkey(payload: any): Promise<AxiosResponse> {
    return api.put("/post/survey/survey-monkey", payload);
  }
  static getCurrentTransmission(): Promise<AxiosResponse> {
    return api.get(`/transmissions/zoom/meeting/current`);
  }
  static getNextTransmissionList(): Promise<AxiosResponse> {
    return api.get(`/transmissions/zoom/meeting/list`);
  }
  static postCreateAccess(
    payload: PayloadTransmissionAccess
  ): Promise<AxiosResponse> {
    return api.post("/transmissions/zoom/meeting/create-access", payload);
  }
}

export default API;
